import React from 'react';
import {cx} from '../util';

import Link from './Link';

export const CardTypes = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};

const SidebarCard = ({
  headerText, bodyText, ctaText, href, onClick, imgUrl, cardType = CardTypes.SECONDARY,
}) => (
  <div className={cx('mt-4 py-4 px-4 rounded-lg cursor-pointer', {
    'bg-gradient-to-r from-indigo-600 to-purple-600': cardType === CardTypes.PRIMARY,
    'border border-gray-200': cardType === CardTypes.SECONDARY,
  })}
  >
    <Link
      href={href}
      target="_blank"
      onClick={onClick}
    >
      {imgUrl && (
        <div className="flex justify-between mb-1">
          <img
            className="w-6 h-6 rounded-full mr-4 object-cover"
            src={imgUrl}
            alt="company logo"
            loading="lazy"
          />
        </div>
      )}
      <h3 className={cx('text-lg font-semibold mb-1 leading-tight tracking-tight', {
        'text-white': cardType === CardTypes.PRIMARY,
      })}
      >
        {headerText}
      </h3>
      <div className={cx('text-sm font-regular mb-3', {
        'text-white': cardType === CardTypes.PRIMARY,
        'text-gray-500': cardType === CardTypes.SECONDARY,
      })}
      >
        {bodyText}
      </div>
      <div className={cx('bg-white border-gray-300 hover:bg-gray-50 w-full py-2 px-4 rounded font-semibold text-center border transition', {
        'text-indigo-600': cardType === CardTypes.PRIMARY,
        'text-gray-700': cardType === CardTypes.SECONDARY,
      })}
      >
        {ctaText}
      </div>
    </Link>
  </div>
);

export default SidebarCard;
